import { useCan } from '@refinedev/core';
import React from 'react';

const TestAccessControl: React.FC = () => {
    const can = useCan({resource:'users',action:'list'});
    return (
        <div>
            {can.data?.can ? <h1>Access Granted</h1> : <h1>Access Denied</h1>}
            <h1>Test Access Control</h1>
            <p>This is a test page for access control.</p>
        </div>
    );
};

export default TestAccessControl;